// export interface SecurityOptions {
//   disableRightClick?: boolean;
//   disableDevTools?: boolean;
//   disableCopy?: boolean;
//   disablePrint?: boolean;
//   disableViewSource?: boolean;
//   showConsoleWarning?: boolean;
//   detectDevTools?: boolean;
// }

let isSecurityEnabled = false;
/** NodeJS.Timeout | null */
let devToolsDetector = null;
/** NodeJS.Timeout | null */
let consoleWarningInterval = null;
/** SecurityOptions */
let currentOptions = {};

// const serviceNameAscii = `
// ▗▄▄▄   ▗▄▖  ▗▄▄▖▗▄▄▖ ▗▖   ▗▄▄▄▖
// ▐▌  █ ▐▌ ▐▌▐▌   ▐▌ ▐▌▐▌   ▐▌
// ▐▌  █ ▐▌ ▐▌▐▌   ▐▛▀▘ ▐▌   ▐▛▀▀▘
// ▐▙▄▄▀ ▝▚▄▞▘▝▚▄▄▖▐▌   ▐▙▄▄▖▐▙▄▄▖
// `;

/**
 * 이벤트 차단 헬퍼
 */
const preventEvent = event => {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
  return false;
};

/**
 * 키보드 이벤트 핸들러
 */
const handleKeyDown = event => {
  const { ctrlKey, metaKey, shiftKey, altKey, key, keyCode } = event;
  const isMac = typeof navigator !== 'undefined' && navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  const cmdOrCtrl = isMac ? metaKey : ctrlKey;

  // 개발자 도구 단축키
  const devToolsKeys = [
    keyCode === 123, // F12
    // Windows/Linux: Ctrl+Shift+I, Mac: Cmd+Option+I
    isMac ? metaKey && altKey && key.toLowerCase() === 'i' : ctrlKey && shiftKey && key.toLowerCase() === 'i',
    // Windows/Linux: Ctrl+Shift+J, Mac: Cmd+Option+J
    isMac ? metaKey && altKey && key.toLowerCase() === 'j' : ctrlKey && shiftKey && key.toLowerCase() === 'j',
    // Windows/Linux: Ctrl+Shift+C, Mac: Cmd+Option+C
    isMac ? metaKey && altKey && key.toLowerCase() === 'c' : ctrlKey && shiftKey && key.toLowerCase() === 'c',
  ];

  // 페이지 소스 보기
  const viewSourceKeys = [
    // Windows/Linux: Ctrl+U
    !isMac && ctrlKey && key.toLowerCase() === 'u',
    // Mac Safari/Chrome/Firefox: Cmd+Option+U
    isMac && metaKey && altKey && key.toLowerCase() === 'u',
  ];

  // 복사/붙여넣기/전체선택
  // const copyPasteKeys = [
  //   cmdOrCtrl && key.toLowerCase() === 'a', // 전체 선택
  //   cmdOrCtrl && key.toLowerCase() === 'c', // 복사
  //   cmdOrCtrl && key.toLowerCase() === 'v', // 붙여넣기
  //   cmdOrCtrl && key.toLowerCase() === 'x', // 잘라내기
  // ];

  // 인쇄
  const printKeys = [
    cmdOrCtrl && key.toLowerCase() === 'p', // Ctrl+P / Cmd+P
  ];

  // 차단할 키 조합 확인
  const shouldBlockDevTools = currentOptions.disableDevTools && devToolsKeys.some(Boolean);
  const shouldBlockViewSource = currentOptions.disableViewSource && viewSourceKeys.some(Boolean);
  // const shouldBlockCopy = currentOptions.disableCopy && copyPasteKeys.some(Boolean);
  const shouldBlockPrint = currentOptions.disablePrint && printKeys.some(Boolean);

  // if (shouldBlockDevTools || shouldBlockViewSource || shouldBlockCopy || shouldBlockPrint) {
  if (shouldBlockDevTools || shouldBlockViewSource || shouldBlockPrint) {
    preventEvent(event);
  }
};

/**
 * 우클릭 방지 설정
 */
const setupRightClickProtection = () => {
  if (typeof document === 'undefined') return;
  document.addEventListener('contextmenu', preventEvent, { passive: false });
};

/**
 * 복사/붙여넣기 방지 설정
 */
const setupCopyProtection = () => {
  // if (typeof document === 'undefined') return;
  // 텍스트 선택 및 드래그 방지
  // document.addEventListener('selectstart', preventEvent, { passive: false });
  // document.addEventListener('dragstart', preventEvent, { passive: false });
  // // CSS 스타일 추가
  // const style = document.createElement('style');
  // style.id = 'web-security-copy-protection';
  // style.textContent = `
  //     * {
  //       -webkit-user-select: none !important;
  //       -moz-user-select: none !important;
  //       -ms-user-select: none !important;
  //       user-select: none !important;
  //       -webkit-touch-callout: none !important;
  //       -webkit-tap-highlight-color: transparent !important;
  //     }
  //     input, textarea, [contenteditable] {
  //       -webkit-user-select: text !important;
  //       -moz-user-select: text !important;
  //       -ms-user-select: text !important;
  //       user-select: text !important;
  //     }
  //     img {
  //       -webkit-user-drag: none !important;
  //       -khtml-user-drag: none !important;
  //       -moz-user-drag: none !important;
  //       -o-user-drag: none !important;
  //       user-drag: none !important;
  //       pointer-events: none !important;
  //     }
  //   `;
  // document.head.appendChild(style);
};

/**
 * 인쇄 방지 설정
 */
const setupPrintProtection = () => {
  if (typeof window === 'undefined') return;

  window.addEventListener('beforeprint', preventEvent, { passive: false });

  // 인쇄 시 내용 숨김 CSS
  const style = document.createElement('style');
  style.id = 'web-security-print-protection';
  style.textContent = `
      @media print {
        body * {
          visibility: hidden !important;
        }
        body::after {
          content: "인쇄가 제한되어 있습니다." !important;
          visibility: visible !important;
          position: absolute !important;
          top: 50% !important;
          left: 50% !important;
          transform: translate(-50%, -50%) !important;
          font-size: 24px !important;
          color: #333 !important;
        }
      }
    `;
  document.head.appendChild(style);
};

/**
 * 콘솔 경고 메시지 설정
 */
// const setupConsoleWarning = () => {
//   return;
// if (typeof console === 'undefined') return;
//
// const showWarning = () => {
//   const warning = [`%c${serviceNameAscii}`, '%c⚠️ 경고 ⚠️', '%c개발자 도구를 사용한 무단 접근이나 콘텐츠 복사는 금지되어 있습니다.\n무단 사용 시 법적 책임을 질 수 있습니다.'].join('\n');
//
//   console.log(warning, 'color: #dddddd; font-size: 14px;', 'color: red; font-size: 20px; font-weight: bold;', 'color: #dddddd; font-size: 14px;');
// };
//
// // 즉시 경고 표시
// showWarning();
//
// // 주기적으로 콘솔 클리어 및 경고 메시지 재출력
// consoleWarningInterval = setInterval(() => {
//   console.clear();
//   showWarning();
// }, 3000);
// };

/**
 * 개발자 도구 감지 처리
 */
const handleDevToolsDetected = () => {
  if (typeof document === 'undefined') return;

  // 기존 오버레이가 있으면 제거
  // const existingOverlay = document.getElementById('web-security-devtools-overlay');
  // if (existingOverlay) return;

  // document.body.style.overflow = 'hidden';

  // // 페이지 콘텐츠만 블러 처리하는 CSS 추가
  // const blurStyle = document.createElement('style');
  // blurStyle.id = 'web-security-blur-style';
  // blurStyle.textContent = `
  //   body > *:not(#web-security-devtools-overlay) {
  // 	filter: blur(5px) !important;
  // 	pointer-events: none !important;
  //   }
  // `;
  // document.head.appendChild(blurStyle);

  // const overlay = document.createElement('div');
  // overlay.id = 'web-security-devtools-overlay';
  // overlay.style.cssText = `
  //   position: fixed !important;
  //   top: 0 !important;
  //   left: 0 !important;
  //   width: 100vw !important;
  //   height: 100vh !important;
  //   background: rgba(0, 0, 0, 0.9) !important;
  //   color: white !important;
  //   line-height: 1.5;
  //   display: flex !important;
  //   justify-content: center !important;
  //   align-items: center !important;
  //   font-size: 24px !important;
  //   z-index: 2147483647 !important;
  //   font-family: Arial, sans-serif !important;
  //   filter: none !important;
  //   pointer-events: auto !important;
  //   white-space: pre-line;
  //   text-align: center;
  // `;
  // overlay.textContent = '개발자 도구가 감지되었습니다.\n개발자 도구를 닫고 페이지를 이용해주세요.';
  // document.body.appendChild(overlay);
};

/**
 * 개발자 도구 오버레이 제거
 */
const removeDevToolsOverlay = () => {
  if (typeof document === 'undefined') return;

  const overlay = document.getElementById('web-security-devtools-overlay');
  const blurStyle = document.getElementById('web-security-blur-style');

  if (overlay) overlay.remove();
  if (blurStyle) blurStyle.remove();

  document.body.style.overflow = '';
};

/**
 * 개발자 도구 감지 설정
 */
const setupDevToolsDetection = () => {
  if (typeof window === 'undefined') return;

  let devToolsOpen = false;

  // 창 크기 변화로 감지
  devToolsDetector = setInterval(() => {
    const widthThreshold = 200;
    const heightThreshold = 200;

    if (window.outerHeight - window.innerHeight > heightThreshold || window.outerWidth - window.innerWidth > widthThreshold) {
      if (!devToolsOpen) {
        devToolsOpen = true;
        handleDevToolsDetected();
      }
    } else if (devToolsOpen) {
      devToolsOpen = false;
      // 개발자 도구가 닫혔을 때 오버레이 제거
      removeDevToolsOverlay();
    }
  }, 500);
};

/**
 * 보안 설정 정리
 */
const cleanupSecurity = () => {
  if (typeof document === 'undefined') return;

  // 이벤트 리스너 제거
  document.removeEventListener('contextmenu', preventEvent);
  document.removeEventListener('keydown', handleKeyDown);
  document.removeEventListener('selectstart', preventEvent);
  document.removeEventListener('dragstart', preventEvent);

  if (typeof window !== 'undefined') {
    window.removeEventListener('beforeprint', preventEvent);
  }

  // 인터벌 정리
  if (devToolsDetector) {
    clearInterval(devToolsDetector);
    devToolsDetector = null;
  }

  if (consoleWarningInterval) {
    clearInterval(consoleWarningInterval);
    consoleWarningInterval = null;
  }

  // 추가한 스타일 제거
  const copyStyle = document.getElementById('web-security-copy-protection');
  const printStyle = document.getElementById('web-security-print-protection');
  const overlay = document.getElementById('web-security-devtools-overlay');

  if (copyStyle) copyStyle.remove();
  if (printStyle) printStyle.remove();
  if (overlay) overlay.remove();

  // 페이지 스타일 복원
  document.body.style.filter = '';
  document.body.style.pointerEvents = '';
};

/**
 * 웹 보안 기능 활성화
 */
export const enableWebSecurity = (options = {}) => {
  if (typeof window === 'undefined') {
    console.warn('WebSecurity: 브라우저 환경에서만 동작합니다.');
    return;
  }

  // 기본 옵션 설정
  const defaultOptions = {
    disableRightClick: true,
    disableDevTools: true,
    disableCopy: true,
    disablePrint: true,
    disableViewSource: true,
    showConsoleWarning: true,
    detectDevTools: true,
  };

  currentOptions = { ...defaultOptions, ...options };
  isSecurityEnabled = true;

  // 기존 보안 설정 정리 (중복 방지)
  cleanupSecurity();

  // 키보드 이벤트 리스너 등록
  document.addEventListener('keydown', handleKeyDown, { passive: false });

  // 각 기능별 설정
  if (currentOptions.disableRightClick) {
    setupRightClickProtection();
  }

  if (currentOptions.disableCopy) {
    setupCopyProtection();
  }

  if (currentOptions.disablePrint) {
    setupPrintProtection();
  }

  // if (currentOptions.showConsoleWarning) {
  //   setupConsoleWarning();
  // }

  if (currentOptions.detectDevTools) {
    setupDevToolsDetection();
  }

  // 페이지 이탈 시 정리
  window.addEventListener('beforeunload', cleanupSecurity);
};

/**
 * 웹 보안 기능 비활성화
 */
export const disableWebSecurity = () => {
  if (!isSecurityEnabled) return;

  cleanupSecurity();
  isSecurityEnabled = false;
  currentOptions = {};
};

/**
 * 보안 상태 확인
 */
export const isWebSecurityEnabled = () => {
  return isSecurityEnabled;
};

export default {
  enable: enableWebSecurity,
  disable: disableWebSecurity,
  isEnabled: isWebSecurityEnabled,
};
